import { Navigate, useRoutes } from "react-router-dom";
import Landing from './pages/Landing';
import Login from './pages/Login';
import Signup from './pages/Signup';
import AuthCallback from './pages/AuthCallback';
import Profile from './pages/Profile';
import NotFound from './pages/NotFound';
import { useAuth } from './hooks/auth';

function requireAuth(status, element) {
    if (status === 'loading') {
        return <p>Loading…</p>;
    }
    if (status === 'unauthenticated') {
        return <Navigate to="/login" replace />;
    }
    return element;
}

// ----------------------------------------------------------------------
export default function Router() {
    const { status } = useAuth();

    return useRoutes([
        {
            path: '/', element: (
                <Landing />
            )
        },
        { path: '/login', element: <Login /> },
        { path: '/signup', element: <Signup /> },
        { path: '/auth/callback', element: <AuthCallback /> },
        { path: '/profile', element: <Profile /> },
        //{ path: '/profile', element: requireAuth(status, <Profile />) },
        { path: '*', element: <NotFound /> },
    ]);
}
